import { render, staticRenderFns } from "./moneybird.vue?vue&type=template&id=51af09ec&"
import script from "./moneybird.vue?vue&type=script&lang=js&"
export * from "./moneybird.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports